import { EvaluationCriteriaServiceInterface } from 'domain/services';
import {
  CloneEvaluationCriteriaUseCaseInterface,
  CreateEvaluationCriteriaUseCaseInterface,
  DeleteEvaluationCriteriaUseCaseInterface,
  GetAllEvaluationCriteriaUseCaseInterface,
  GetEvaluationCriteriaByIdUseCaseInterface,
  UpdateEvaluationCriteriaUseCaseInterface,
} from 'domain/usecases';

interface UseCasesInjection {
  cloneEvaluationCriteria: CloneEvaluationCriteriaUseCaseInterface;
  getAllEvaluationCriteria: GetAllEvaluationCriteriaUseCaseInterface;
  createEvaluationCriteria: CreateEvaluationCriteriaUseCaseInterface;
  updateEvaluationCriteria: UpdateEvaluationCriteriaUseCaseInterface;
  deleteEvaluationCriteria: DeleteEvaluationCriteriaUseCaseInterface;
  getEvaluationCriteriaById: GetEvaluationCriteriaByIdUseCaseInterface;
}

export class EvaluationCriteriaService
  implements EvaluationCriteriaServiceInterface
{
  private readonly _cloneEvaluationCriteria: CloneEvaluationCriteriaUseCaseInterface;
  private readonly _getAllEvaluationCriteria: GetAllEvaluationCriteriaUseCaseInterface;
  private readonly _createEvaluationCriteria: CreateEvaluationCriteriaUseCaseInterface;
  private readonly _updateEvaluationCriteria: UpdateEvaluationCriteriaUseCaseInterface;
  private readonly _deleteEvaluationCriteria: DeleteEvaluationCriteriaUseCaseInterface;
  private readonly _getEvaluationCriteriaById: GetEvaluationCriteriaByIdUseCaseInterface;

  constructor(usecases: UseCasesInjection) {
    this._cloneEvaluationCriteria = usecases.cloneEvaluationCriteria;
    this._getAllEvaluationCriteria = usecases.getAllEvaluationCriteria;
    this._createEvaluationCriteria = usecases.createEvaluationCriteria;
    this._updateEvaluationCriteria = usecases.updateEvaluationCriteria;
    this._deleteEvaluationCriteria = usecases.deleteEvaluationCriteria;
    this._getEvaluationCriteriaById = usecases.getEvaluationCriteriaById;
  }

  cloneEvaluationCriteria(
    params: CloneEvaluationCriteriaUseCaseInterface.Params,
  ): Promise<CloneEvaluationCriteriaUseCaseInterface.Result> {
    return this._cloneEvaluationCriteria.execute(params);
  }

  getAllEvaluationCriteria(): Promise<GetAllEvaluationCriteriaUseCaseInterface.Result> {
    return this._getAllEvaluationCriteria.execute();
  }

  createEvaluationCriteria(
    params: CreateEvaluationCriteriaUseCaseInterface.Params,
  ): Promise<CreateEvaluationCriteriaUseCaseInterface.Result> {
    return this._createEvaluationCriteria.execute(params);
  }

  updateEvaluationCriteria(
    params: UpdateEvaluationCriteriaUseCaseInterface.Params,
  ): Promise<UpdateEvaluationCriteriaUseCaseInterface.Result> {
    return this._updateEvaluationCriteria.execute(params);
  }

  getEvaluationCriteriaById(
    params: GetEvaluationCriteriaByIdUseCaseInterface.Params,
  ): Promise<GetEvaluationCriteriaByIdUseCaseInterface.Result> {
    return this._getEvaluationCriteriaById.execute(params);
  }

  deleteEvaluationCriteria(
    params: DeleteEvaluationCriteriaUseCaseInterface.Params,
  ): Promise<DeleteEvaluationCriteriaUseCaseInterface.Result> {
    return this._deleteEvaluationCriteria.execute(params);
  }
}
